import Cookies from 'js-cookie'

const userInfo = {
  state: {
    username: '',
    email: ''
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    INIT_USERINFO: (state) => {
      state.username = Cookies.get('username');//localStorage.getItem('username');
      state.email = Cookies.get('email'); //localStorage.getItem('email');
    },
    SET_USERINFO: (state, data) => {
      state.username = data.username;
      state.email = data.email;
    }
  },
  actions: {
    init_userinfo: ({ commit }) => {
      commit('INIT_USERINFO')
    },
    set_userinfo: ({ commit }, data) => {
      commit('SET_USERINFO', data)
    }
  }
}

export default userInfo



// WEBPACK FOOTER //
// ./src/store/modules/user.js